module.exports = __webpack_public_path__ + "static/media/StrengthsIdentification.63997b9c.mp3";